import React, { useState, useEffect } from "react";
import "./Connectfour.css";
import taskBg from "../../../assets/Task/task-bg.png";
import { Container, Row, Col, Button, ButtonGroup } from "react-bootstrap";
import task from "../Task";
import { useAudio } from "../../../Providers/AudioProvider";
import { logPageView } from "../../../components/analytics";
import useUserInfo from "../../../Hooks/useUserInfo";
import { userGameRewards } from "../../../apis/user";

const ConnectFour = () => {
  const ROWS = 6;
  const COLS = 7;
  const EMPTY = null;
  const PLAYER = "red";
  const AI = "yellow";
  const DIFFICULTY_LEVELS = ["Easy", "Medium", "Hard"];
  const DIFFICULTY_SCORES = {
    Easy: 500,
    Medium: 1000,
    Hard: 1500,
  };

  useEffect(() => {
    logPageView("ConnectFourPage", "Connect Four Game");
  }, []);

  // Game state
  const [board1, setboard1] = useState(createEmptyboard1());
  const [currentPlayer, setCurrentPlayer] = useState(PLAYER);
  const [winner, setWinner] = useState(null);
  const [isDraw, setIsDraw] = useState(false);
  const [winningcell1s, setWinningcell1s] = useState([]);
  const [isDropping, setIsDropping] = useState(false);
  const [lastCol, setLastCol] = useState(null);
  const [playerScore, setPlayerScore] = useState(0);
  const [currentGameScore, setCurrentGameScore] = useState(0);
  const [totalScore, setTotalScore] = useState(() => {
    const saved = localStorage.getItem("connectFourTotalScore");
    return saved ? parseInt(saved) : 0;
  });
  const [aiScore, setAiScore] = useState(0);
  const [gameMode, setGameMode] = useState("vsAI");
  const [difficulty, setDifficulty] = useState(() => {
    // Get saved easy plays data
    const savedData = localStorage.getItem("connectFourEasyData");
    let easyPlaysData = { count: 0, date: "" };

    if (savedData) {
      try {
        easyPlaysData = JSON.parse(savedData);
        // Check if it's a new day
        const today = new Date().toLocaleDateString();
        if (easyPlaysData.date !== today) {
          // Reset count for new day
          easyPlaysData = { count: 0, date: today };
          localStorage.setItem(
            "connectFourEasyData",
            JSON.stringify(easyPlaysData)
          );
        }
      } catch (e) {
        console.error("Error parsing saved easy play data", e);
      }
    } else {
      // Initialize with today's date
      easyPlaysData = { count: 0, date: new Date().toLocaleDateString() };
      localStorage.setItem(
        "connectFourEasyData",
        JSON.stringify(easyPlaysData)
      );
    }

    // Start with Medium if player has used all easy plays for today
    return easyPlaysData.count >= 3
      ? DIFFICULTY_LEVELS[1]
      : DIFFICULTY_LEVELS[0];
  });
  const [isThinking, setIsThinking] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [easyPlays, setEasyPlays] = useState(() => {
    // Get saved easy plays data
    const savedData = localStorage.getItem("connectFourEasyData");
    let easyPlaysData = { count: 0, date: "" };

    if (savedData) {
      try {
        easyPlaysData = JSON.parse(savedData);
        // Check if it's a new day
        const today = new Date().toLocaleDateString();
        if (easyPlaysData.date !== today) {
          // Reset count for new day
          easyPlaysData = { count: 0, date: today };
          localStorage.setItem(
            "connectFourEasyData",
            JSON.stringify(easyPlaysData)
          );
        }
      } catch (e) {
        console.error("Error parsing saved easy play data", e);
      }
    } else {
      // Initialize with today's date
      easyPlaysData = { count: 0, date: new Date().toLocaleDateString() };
      localStorage.setItem(
        "connectFourEasyData",
        JSON.stringify(easyPlaysData)
      );
    }

    return easyPlaysData.count;
  });
  const [pointsAwarded, setPointsAwarded] = useState(false);
  const { userDetails, updateUserInfo, updatewatchScreenInfo, watchScreen } =
    useUserInfo();
  const playClick = useAudio();

  const handleApiResponse = async (points) => {
    if (points <= 0 || pointsAwarded) {
      return;
    }

    setPointsAwarded(true);
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    try {
      const apiData = {
        gamePoints: points,
        gameType: "connectfour",
      };
      const res = await userGameRewards(apiData);
      if (res) {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
        setGameOver(true);
        // Increment easy plays counter when game ends in Easy mode
        if (difficulty === "Easy") {
          const today = new Date().toLocaleDateString();
          const newCount = easyPlays + 1;

          // Save count with date
          const easyPlaysData = { count: newCount, date: today };
          localStorage.setItem(
            "connectFourEasyData",
            JSON.stringify(easyPlaysData)
          );

          setEasyPlays(newCount);

          // Automatically switch to Medium if Easy limit reached
          if (newCount >= 3) {
            setDifficulty("Medium");
          }
        }
      }
    } catch (error) {
      console.error("API call failed:", error);
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
      setGameOver(true);
    }
  };

  function createEmptyboard1() {
    return Array(ROWS)
      .fill()
      .map(() => Array(COLS).fill(EMPTY));
  }

  function resetGame() {
    setboard1(createEmptyboard1());
    setCurrentPlayer(PLAYER);
    setWinner(null);
    setIsDraw(false);
    setWinningcell1s([]);
    setIsDropping(false);
    setLastCol(null);
    setIsThinking(false);
    setGameOver(false);
    setCurrentGameScore(0);
    setPointsAwarded(false);
  }

  const IsPointsReached =
    watchScreen?.LoginMessage ==
    "You have already reached the maximum rewards limit"
      ? true
      : false;

  const closePopUp = () => {
    setGameOver(false);
    resetGame();
  };

  // AI move logic
  useEffect(() => {
    if (
      gameMode === "vsAI" &&
      currentPlayer === AI &&
      !winner &&
      !isDraw &&
      !isDropping
    ) {
      setIsThinking(true);
      const thinkingTime =
        difficulty === "Easy" ? 500 : difficulty === "Medium" ? 800 : 1200;

      const aiTimer = setTimeout(() => {
        makeAiMove();
        setIsThinking(false);
      }, thinkingTime);

      return () => clearTimeout(aiTimer);
    }
  }, [currentPlayer, winner, isDraw, isDropping, gameMode]);

  function makeAiMove() {
    let col;
    const random = Math.random();

    switch (difficulty) {
      case "Easy":
        // 80% chance to make a random move (player wins), 20% chance to make a smart move
        col = random < 0.8 ? makeRandomMove() : findBestMove(board1, 2);
        break;
      case "Medium":
        // 20% chance to make a random move, 80% chance to make a smart move
        col = random < 0.2 ? makeRandomMove() : findBestMove(board1, 5);
        break;
      case "Hard":
        // 5% chance to make a random move, 95% chance to make a smart move
        col = random < 0.05 ? makeRandomMove() : findBestMove(board1, 7);
        break;
      default:
        col = makeRandomMove();
    }
    handleColumnClick(col);
  }

  function makeRandomMove() {
    const availableCols = [];
    for (let col = 0; col < COLS; col++) {
      if (findAvailableRow(col) !== -1) {
        availableCols.push(col);
      }
    }
    return availableCols[Math.floor(Math.random() * availableCols.length)];
  }

  function findBestMove(board1, depth) {
    let bestScore = -Infinity;
    let bestCol = 0;
    let availableCols = [];

    // First check if AI can win in the next move
    for (let col = 0; col < COLS; col++) {
      const row = findAvailableRow(col);
      if (row !== -1) {
        const board1Copy = board1.map((r) => [...r]);
        board1Copy[row][col] = AI;
        if (checkWinCondition(board1Copy, row, col)) {
          return col;
        }
        availableCols.push(col);
      }
    }

    // Then check if player can win in the next move and block it
    for (let col = 0; col < COLS; col++) {
      const row = findAvailableRow(col);
      if (row !== -1) {
        const board1Copy = board1.map((r) => [...r]);
        board1Copy[row][col] = PLAYER;
        if (checkWinCondition(board1Copy, row, col)) {
          return col;
        }
      }
    }

    // If no immediate win or block, make a strategic move
    for (let col of availableCols) {
      const row = findAvailableRow(col);
      const board1Copy = board1.map((r) => [...r]);
      board1Copy[row][col] = AI;

      // Evaluate the move based on potential connections
      const score = evaluateMove(board1Copy, row, col);
      if (score > bestScore) {
        bestScore = score;
        bestCol = col;
      }
    }

    return bestCol;
  }

  function evaluateMove(board1, row, col) {
    let score = 0;
    const directions = [
      { dr: 0, dc: 1 }, // horizontal
      { dr: 1, dc: 0 }, // vertical
      { dr: 1, dc: 1 }, // diagonal down-right
      { dr: 1, dc: -1 }, // diagonal down-left
    ];

    // Evaluate AI's potential connections
    for (const { dr, dc } of directions) {
      const connected = countConnected(board1, row, col, dr, dc, AI);
      if (connected >= 3) score += 1000; // Very high score for potential win
      if (connected === 2) score += 100; // High score for building
      if (connected === 1) score += 10; // Medium score for starting
    }

    // Evaluate player's potential connections to block
    for (const { dr, dc } of directions) {
      const connected = countConnected(board1, row, col, dr, dc, PLAYER);
      if (connected >= 3) score += 800; // High score for blocking player's win
      if (connected === 2) score += 80; // Medium score for blocking player's build
    }

    // Prefer center columns
    if (col === 3) score += 50;
    if (col === 2 || col === 4) score += 30;
    if (col === 1 || col === 5) score += 10;

    return score;
  }

  function handleColumnClick(col) {
    if (winner || isDraw || isDropping || isThinking) return;
    if (difficulty === "Easy" && easyPlays >= 3) return;

    const row = findAvailableRow(col);
    if (row === -1) return;

    // Clear any previous winning highlights at the start of each move
    setWinningcell1s([]);
    setIsDropping(true);
    setLastCol(col);

    // Update board immediately
    const newboard1 = [...board1];
    newboard1[row][col] = currentPlayer;
    setboard1(newboard1);

    // Check win condition after board update
    if (checkWinCondition(newboard1, row, col)) {
      setWinner(currentPlayer);
      if (currentPlayer === PLAYER) {
        const scoreToAdd = DIFFICULTY_SCORES[difficulty];
        setCurrentGameScore(scoreToAdd);
        setPlayerScore(scoreToAdd);
        setTotalScore((prev) => {
          const newTotal = prev + scoreToAdd;
          localStorage.setItem("connectFourTotalScore", newTotal.toString());
          return newTotal;
        });
        handleApiResponse(scoreToAdd);
      } else {
        // AI wins - increment easy plays counter if in Easy mode
        if (difficulty === "Easy") {
          const today = new Date().toLocaleDateString();
          const newCount = easyPlays + 1;

          // Save count with date
          const easyPlaysData = { count: newCount, date: today };
          localStorage.setItem(
            "connectFourEasyData",
            JSON.stringify(easyPlaysData)
          );

          setEasyPlays(newCount);

          // Automatically switch to Medium if Easy limit reached
          if (newCount >= 3) {
            setDifficulty("Medium");
          }
        }

        // Add delay to show winning connection before showing popup when AI wins
        setTimeout(() => {
          setGameOver(true);
        }, 1500); // 1.5 second delay to show the winning connection
      }
    } else if (checkFullboard1(newboard1)) {
      setIsDraw(true);

      // Draw - increment easy plays counter if in Easy mode
      if (difficulty === "Easy") {
        const today = new Date().toLocaleDateString();
        const newCount = easyPlays + 1;

        // Save count with date
        const easyPlaysData = { count: newCount, date: today };
        localStorage.setItem(
          "connectFourEasyData",
          JSON.stringify(easyPlaysData)
        );

        setEasyPlays(newCount);

        // Automatically switch to Medium if Easy limit reached
        if (newCount >= 3) {
          setDifficulty("Medium");
        }
      }

      setGameOver(true);
    } else {
      setCurrentPlayer(currentPlayer === PLAYER ? AI : PLAYER);
    }

    setIsDropping(false);
  }

  function findAvailableRow(col) {
    for (let row = ROWS - 1; row >= 0; row--) {
      if (board1[row][col] === EMPTY) {
        return row;
      }
    }
    return -1;
  }

  function checkFullboard1(board1) {
    return board1[0].every((cell1) => cell1 !== EMPTY);
  }

  function checkWinCondition(board1, row, col) {
    const directions = [
      { dr: 0, dc: 1 }, // horizontal
      { dr: 1, dc: 0 }, // vertical
      { dr: 1, dc: 1 }, // diagonal down-right
      { dr: 1, dc: -1 }, // diagonal down-left
    ];

    const player = board1[row][col];

    for (const { dr, dc } of directions) {
      const connected = countConnected(board1, row, col, dr, dc, player);
      if (connected >= 4) {
        const winCoords = getWinningCoordinates(row, col, dr, dc, connected);
        setWinningcell1s(winCoords);
        return true;
      }
    }

    return false;
  }

  function countConnected(board1, row, col, dr, dc, player) {
    let count = 1;

    for (let i = 1; i <= 3; i++) {
      const r = row + dr * i;
      const c = col + dc * i;
      if (r < 0 || r >= ROWS || c < 0 || c >= COLS) break;
      if (board1[r][c] !== player) break;
      count++;
    }

    for (let i = 1; i <= 3; i++) {
      const r = row - dr * i;
      const c = col - dc * i;
      if (r < 0 || r >= ROWS || c < 0 || c >= COLS) break;
      if (board1[r][c] !== player) break;
      count++;
    }

    return count;
  }

  function getWinningCoordinates(row, col, dr, dc, count) {
    const coords = [];
    // Use the player from the board cell instead of currentPlayer
    const player = board1[row][col];

    for (let i = -3; i <= 3; i++) {
      const r = row + dr * i;
      const c = col + dc * i;
      if (r < 0 || r >= ROWS || c < 0 || c >= COLS) continue;
      if (board1[r][c] === player) {
        coords.push([r, c]);
        if (coords.length === 4) break;
      }
    }
    return coords;
  }

  function isWinningcell1(row, col) {
    // Only highlight winning cells if there's actually a winner
    return winner && winningcell1s.some(([r, c]) => r === row && c === col);
  }

  // function toggleGameMode() {
  //   const newMode = gameMode === "vsAI" ? "vsAI" : "vsAI";
  //   setGameMode(newMode);
  //   resetGame();
  // }

  function changeDifficulty(level) {
    playClick();

    // If trying to switch to Easy mode but already reached limit
    if (level === "Easy" && easyPlays >= 3) {
      return; // Don't allow the change
    }

    setDifficulty(level);
    resetGame();
  }
  const toogleMenu = () => {
    playClick();
    // Clear the local storage for connectFourTotalScore
    localStorage.removeItem("connectFourTotalScore");
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  // Add these visual elements to show the remaining easy plays
  function getEasyModeRemaining() {
    if (difficulty !== "Easy") {
      return "";
    }

    const remaining = 3 - easyPlays;
    if (remaining <= 0) {
      return "(Max)";
    }
    return `(${remaining} left)`;
  }

  return (
    <Container fluid className="game-container p-0">
      <img
        onClick={() => {
          toogleMenu(task, "task");
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-full "
        style={{ cursor: "pointer" }}
      />
      <Row className="justify-content-center align-items-center min-vh-100 m-0">
        <Col xs={12} md={8} lg={10} className="p-4">
          <div className="connect-four rounded-4 shadow-lg p-4">
            <h2 className="text-center mb-3  text-uppercase text-white welcome-text">
              Connect Four
            </h2>

            {/* Game controls */}
            <div className="d-flex flex-wrap justify-content-center gap-3 mb-2">
              {gameMode === "vsAI" && (
                <div className="d-flex align-items-center">
                  <span className="me-2 text-white text-uppercase">
                    Difficulty:
                  </span>
                  <buttonGroup>
                    {DIFFICULTY_LEVELS.map((level) => (
                      <button
                        key={level}
                        className={
                          difficulty === level ? "selected" : "unselected"
                        }
                        onClick={() => changeDifficulty(level)}
                        disabled={level === "Easy" && easyPlays >= 3}
                      >
                        {level}
                        {level === "Easy" && getEasyModeRemaining()}
                      </button>
                    ))}
                  </buttonGroup>
                </div>
              )}
            </div>
            {/* Score and game status */}
            <div className="d-flex justify-content-between mb-2">
              <div
                className={`p-2 ${
                  currentPlayer === PLAYER && !winner && !isDraw
                    ? "bg-black bg-opacity-1"
                    : ""
                }`}
              >
                <span className="text-grey text-uppercase">
                  Score: {totalScore}
                </span>
              </div>
              <div className="d-flex align-items-center text-white">
                {winner ? (
                  <div className="text-grey">
                    <span
                      className={
                        winner === PLAYER ? "text-grey" : "text-warning"
                      }
                    >
                      {winner === PLAYER ? "You" : "THEMEMETV"} WINS!
                    </span>
                  </div>
                ) : isDraw ? (
                  <div className="text-grey">Draw!</div>
                ) : (
                  <div>
                    <span className="text-grey text-uppercase">Turn: </span>
                    <span>
                      {currentPlayer === PLAYER
                        ? "YOU"
                        : isThinking
                        ? "THEMEMETV"
                        : "THEMEMETV"}
                    </span>
                  </div>
                )}
              </div>
              {/* <div
                className={`p-2 rounded ${
                  currentPlayer === AI && !winner && !isDraw
                    ? "bg-warning bg-opacity-10"
                    : ""
                }`}
              >
                <span className="fw-bold">
                  Yellow{gameMode === "vsAI" ? " (AI)" : ""}:{" "}
                </span>
                {aiScore}
              </div> */}
            </div>

            {/* Game board1 */}
            <div className="board1 mx-auto" style={{ position: "relative" }}>
              {/* Column hover areas */}

              {/* board1 grid */}
              {board1.map((row, rowIndex) => (
                <div key={`row-${rowIndex}`} className="flexconnect">
                  {row.map((cell1, colIndex) => (
                    <div
                      key={`cell1-${rowIndex}-${colIndex}`}
                      className="cell1"
                      onClick={() =>
                        currentPlayer === PLAYER
                          ? handleColumnClick(colIndex)
                          : null
                      }
                    >
                      {cell1 && (
                        <div
                          className={`piece ${
                            cell1 === PLAYER ? "bg-danger" : "bg-warning"
                          } ${
                            isWinningcell1(rowIndex, colIndex) ? "winning" : ""
                          }`}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <div className="flex mt-2">
              <button
                onClick={resetGame}
                className="text-uppercase control-btn"
              >
                Reset Game
              </button>
            </div>

            {/* Game instructions */}
            <div className="mt-3 text-center text-muted small text-uppercase">
              <p style={{ marginBottom: "0px", color: "#6a6968" }}>
                Drop your red pieces by clicking on a column. Try to connect
                four in a row horizontally, vertically, or diagonally before the
                THEMEMETV does!
              </p>
            </div>
          </div>
        </Col>
      </Row>
      {gameOver && (
        <div className="overlay">
          <div className="full-popup">
            <div className="popup-content">
              <h2 className="epic">GAME OVER!</h2>
              <img
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                className="cancel-img"
                onClick={closePopUp}
              />
              {!IsPointsReached ? (
                <div className="row text-center">
                  <div className="col-12">
                    <div className="epic-div" style={{ padding: "30px 40px" }}>
                      <p className="pointsLabel">TOKENS EARNED</p>
                      <div className="pointsValue1">
                        <img
                          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                          alt="logo"
                        />
                        <p className="pointsNumber">
                          {winner === PLAYER ? playerScore : 0}
                        </p>
                      </div>
                      <p className="winner-text1">
                        {winner === PLAYER
                          ? "Winner : You"
                          : isDraw
                          ? "Game Draw!"
                          : "Winner : Thememetv"}
                      </p>
                    </div>
                    <p className="bottom-text">
                      Play daily to boost your score and rack up more Tokens!
                    </p>
                  </div>
                </div>
              ) : (
                <div className="row text-center">
                  <div className="col-12">
                    <div className="epic-div">
                      <p className="pointsLabel">
                        {winner === PLAYER
                          ? `TOKENS EARNED: ${playerScore}`
                          : "TOKENS EARNED: 0"}
                        <br />
                        TOKENS EARNED: NIL
                      </p>
                      <p
                        className="winner-text1"
                        style={{ marginBottom: "0px" }}
                      >
                        {winner === PLAYER
                          ? "Winner : You"
                          : isDraw
                          ? "Game Draw!"
                          : "Winner : Thememetv"}
                      </p>
                    </div>
                    <p className="bottom-text">
                      Keep playing & Connect four Dots & get Tokens!
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Container>
  );
};

export default ConnectFour;
